import { Role } from '../interfaces/auth.interface';
import { useAppSelector } from './useAppSelector';

export default function useCanExtractData() {
  const user = useAppSelector((state) => state.user);
  const { adminGroup: adminGroups, group: userGroup, role } = user;

  if (role && Role.SUPERADMIN === role) {
    return true;
  }

  if (!userGroup || !userGroup.adminExtractData || !adminGroups?.length) {
    return false;
  }

  return adminGroups.includes(userGroup.id);
}
